<template>
  <v-layout row wrap class="mt-5">
    <form-dialog v-model="dialog" :title="formTitle" @input="reset">
      <v-sheet class="py-2 px-4">
        <v-text-field
          :label="$t('name')"
          data-vv-name="name"
          v-model="member.name"
          v-validate="'required'"
          :data-vv-as="$t('name')"
          :error-messages="errors.collect('name')"
        />
        <v-text-field
          :label="$t('position')"
          v-validate="'required'"
          data-vv-name="position"
          v-model="member.position"
          :data-vv-as="$t('position')"
          :error-messages="errors.collect('position')"
        />
        <div class="my-2 di-flex justify-end">
          <v-btn color="btn_color secondary" :loading="loading" @click="save">
            {{ $t("save") }}
          </v-btn>
        </div>
      </v-sheet>
    </form-dialog>

    <v-flex xs12 class="di-flex justify-space-between align-center">
      <strong class="title_label">{{ $t(`${type}s`) }}</strong>
      <v-spacer />
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            small
            v-on="on"
            class="shadow"
            color="primary"
            v-if="can('edit_CSOs')"
            @click="dialog = true"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>Add New Item</span>
      </v-tooltip>
    </v-flex>

    <v-flex xs12>
      <v-data-table
        item-key="id"
        hide-actions
        :items="items"
        :headers="headers"
        disable-initial-sort
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.index + 1 }}</td>
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.position }}</td>
          <td>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  flat
                  small
                  v-on="on"
                  class="ma-0 pa-0"
                  color="grey darken-2"
                  v-if="can('edit_CSOs')"
                  @click="editItem(props.item)"
                >
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
              </template>
              <span>Edit</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  flat
                  small
                  v-on="on"
                  class="ma-0 pa-0"
                  color="grey darken-2"
                  v-if="can('edit_CSOs')"
                  @click="deleteItem(props.item)"
                >
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
              <span>Delete</span>
            </v-tooltip>
          </td>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: ["type"],
  name: "CSOMembers",
  data() {
    return {
      member: {},
      items: [],
      dialog: false,
      loading: false,
      editedIndex: -1
    };
  },
  computed: {
    headers: vm => [
      { text: vm.$t("id"), sortable: false, width: "100px" },
      { text: vm.$t("name"), value: "name" },
      { text: vm.$t("position"), value: "position" },
      { text: vm.$t("actions"), sortable: false, width: "200px" }
    ],

    formTitle: vm =>
      vm.editedIndex > -1 ? `Edit ${vm.type}` : `New ${vm.type}`
  },

  methods: {
    deleteItem(item) {
      let vm = this;
      this.$alert(`/members/${item.id}`).then(() => {
        vm.items.splice(vm.items.indexOf(item), 1);
      });
    },

    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.member = Object.assign({}, item);
      this.dialog = true;
    },

    reset() {
      this.member = {
        id: null,
        name: null,
        position: null,
        type: this.type,
        CSO_id: this.$route.params.id
      };
      this.dialog = false;
      this.loading = false;
      this.editedIndex = -1;
      this.$validator.reset();
    },

    save() {
      this.loading = true;
      this.$validator.validateAll().then(succeed => {
        if (succeed) {
          this.axios
            .post("members", this.member)
            .then(res => {
              if (this.editedIndex > -1)
                Object.assign(this.items[this.editedIndex], res.data.data);
              else this.items.push(res.data.data);
              this.reset();
            })
            .catch(() => (this.loading = false));
        } else {
          this.loading = false;
          this.$store.commit("showSnackbar", {
            text: this.$t("wrong_input"),
            stateType: "error",
            show: true
          });
        }
      });
    }
  },

  created() {
    this.reset();
    let CSO_id = this.$route.params.id;
    this.axios.get(`members?CSO_id=${CSO_id}&&type=${this.type}`).then(res => {
      this.items = res.data.data;
    });
  }
};
</script>
